export default __webpack_public_path__ + "static/media/sign-up-background.a385baaf.jpg";